import { Component, inject, OnInit, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import { SessionStoreRepository } from "../../shared/repositories/session.repository";

@Component({
    selector: "wp-single-logout",
    templateUrl: "./single-logout.component.html",
    imports: [TranslocoDirective]
})
export class SingleLogoutComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly sessionService = inject(SessionStoreRepository);

  readonly hasError = signal(false);

  public ngOnInit() {
    const returnUrl = this.route.snapshot.queryParamMap.get("returnUrl");

    this.sessionService.resetStores();
    
    if (returnUrl === null) {
      this.hasError.set(true);
      return;
    }


    if (!returnUrl || returnUrl === '') {
      this.sessionService.redirectToStsLogoutPage();
    } else {
      window.location.href = returnUrl;
    }
  }

  onWelcomeClick() {
    this.router.navigate(["/welcome"]);
  }
}
